var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuTrial(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.198,
    height: 19.679,
    viewBox: "0 0 24.198 19.679",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "booking_trial_class",
    transform: "translate(0 -15.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25288",
    "data-name": "Path 25288",
    d: "M19.222,15.5H4.976a4.976,4.976,0,0,0,0,9.952H19.222a4.976,4.976,0,0,0,0-9.952Z",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25289",
    "data-name": "Path 25289",
    d: "M233.277,20.476a4.982,4.982,0,0,1-4.976,4.976h-8.85V15.5h8.85A4.982,4.982,0,0,1,233.277,20.476Z",
    transform: "translate(-209.078)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25290",
    "data-name": "Path 25290",
    d: "M48.752,53.7h-15a4.117,4.117,0,0,1,0-8.2h15a4.117,4.117,0,0,1,0,8.2Z",
    transform: "translate(-29.189 -29.134)",
    fill: "#e4efff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25291",
    "data-name": "Path 25291",
    d: "M231.859,49.534a3.823,3.823,0,0,1-3.558,4.034h-8.85V45.5h8.85A3.823,3.823,0,0,1,231.859,49.534Z",
    transform: "translate(-208.597 -29.072)",
    fill: "#cee2ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25292",
    "data-name": "Path 25292",
    d: "M107.253,113.035v3.64l-.139.158h-6.28l-.216-.158L98.385,114.8A1.178,1.178,0,1,1,99.9,113l.718.6v-5.913a1.185,1.185,0,1,1,2.37,0v3.6l3,.332A1.421,1.421,0,0,1,107.253,113.035Z",
    transform: "translate(-90.548 -83.644)",
    fill: "#fddbcc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25293",
    "data-name": "Path 25293",
    d: "M224.9,113.035v3.64l-.139.158H219.45V106.5a1.186,1.186,0,0,1,1.185,1.185v3.6l3,.332A1.421,1.421,0,0,1,224.9,113.035Z",
    transform: "translate(-208.194 -83.644)",
    fill: "#fbcdbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25294",
    "data-name": "Path 25294",
    d: "M188.585,428.5v1.675a.474.474,0,0,1-.474.474h-5.687a.474.474,0,0,1-.474-.474V428.5Z",
    transform: "translate(-171.879 -395.47)",
    fill: "#00347b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25295",
    "data-name": "Path 25295",
    d: "M224.9,428.5v1.675a.474.474,0,0,1-.474.474H219.45V428.5Z",
    transform: "translate(-208.194 -395.47)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25296",
    "data-name": "Path 25296",
    d: "M306.363,75.708a.709.709,0,0,0-1,0l-2.334,2.334-.917-.917a.709.709,0,0,0-1,1l1.418,1.418a.709.709,0,0,0,1,0l2.836-2.836A.709.709,0,0,0,306.363,75.708Z",
    transform: "translate(-284.678 -57.165)",
    fill: "#285caa"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Book",
    transform: "translate(2.099 22.366)",
    fill: "#393939",
    fontSize: 5,
    fontFamily: "Montserrat-Medium, Montserrat",
    fontWeight: 500
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Book")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuTrial);
export default __webpack_public_path__ + "static/media/menu-trial.118ddce56fd69ca354a944682bbf9677.svg";
export { ForwardRef as ReactComponent };